module.exports = __webpack_public_path__ + "assets/img/img264.c19f2f45.png";